<template>
  <section style="min-height: 400px;">
    <b-tabs
      v-if="area"
      v-model="activeTab"
      :animated="false"
      class="boarder-tabs"
      destroyOnHide
      multiline
      expanded
    >
      <b-tab-item :label="$t('attributes.banner')" :disabled="loading">
        <banner-list :area="area" />
      </b-tab-item>

      <b-tab-item :label="$t('attributes.abs_block')" :disabled="loading">
        <remark-form :area="area" @updated="onUpdated" />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import BannerList from './BannerList'
import RemarkForm from './RemarkForm'

export default {
  name: 'AreaHome',
  components: {
    BannerList,
    RemarkForm
  },

  props: {
    code: {
      required: true,
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0,
      area: null
    }
  },
  watch: {
    code(newCode) {
      this.loadAsync(newCode)
    }
  },
  mounted() {
    this.loadAsync(this.code)
  },
  methods: {
    async loadAsync(code) {
      try {
        this.$emit('update:loading', true)

        const res = await this.axios.get(`${AREA_API}/${code}`)
        this.area = res.data.data
      } catch (e) {
        this.area = null

        notifyService.fetch_error('area', e)
      } finally {
        this.$emit('update:loading', false)
      }
    },
    onUpdated(area) {
      this.area = area

      this.$emit('updated', area)
    }
  }
}
</script>
